import { Routes } from '@angular/router';

export const REQUEST_ACCESS_ROUTES: Routes = [
  {
    path: 'requests',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/request-access/request-access-directory/request-access-directory.component').then(
            (c) => c.RequestAccessDirectoryComponent,
          ),
        data: { layout: 'private' },
      },
    ],
  },
];
